var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-bar-drawer",class:[
		_vm.drawerDir,
		{
			'is-drawer-open': _vm.isSideBarDrawerOpen,
			'transactional-emails': _vm.isTransactionalEmails,
		},
		_vm.isCodeBlock ? 'code-block' : 'height-100',
	]},[_c('SideBarDrawerKnob',{attrs:{"drawerDir":_vm.drawerDir}}),(_vm.isSideBarDrawerOpen)?_c('SideBarDrawerContent',{staticClass:"table-preview",attrs:{"isCodeBlock":_vm.isCodeBlock,"isTransactionalEmails":_vm.isTransactionalEmails}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }